import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
import { Footer, Header } from '../Common';
import { SideBar } from '../Common/SideBar';
import FollowFavourites from '../../Models/FollowFavourites'
import Pagination from "react-js-pagination";
import StarRatingComponent from 'react-star-rating-component';
import StarRatings from 'react-star-ratings';
import Common from "../../Models/Common";
var striptags = require('striptags');
class SellerFavorites extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 2) {
            alert(this.props.t('0'))
            this.props.history.push('/login/seller');
        };
        var logged_user = JSON.parse(window.localStorage.getItem('info'));
        this.state = {
            _id: false,
            user: '',
            activePage: 1,
            itemsCountPerPage: 10,
            pageRangeDisplayed: '',
            total: [],
            favorites: []
        }
        this.state.user = logged_user.id;
    };

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    componentWillMount() {
        FollowFavourites.getFavourites(this.state.user, 1).then(res => {
            if (res.data.payload != null) {
                this.setState({ favorites: res.data.payload })
            }
        })
    }
    handlePageChange(pageNumber) {
        // console.log(pageNumber)
        FollowFavourites.getFavourites(this.state.user, pageNumber).then(res => {
            if (res.data.payload != null) {
                this.setState({ favorites: res.data.payload, total: res.data.total, activePage: pageNumber, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage })
            }
        })
    }

    pagination() {
        if (this.state.total >= 10) {
            return (<div className="row">
                <div className="col-md-4"></div>
                <div className="col-md-6 ml-5">
                    <Pagination
                        hideNavigation
                        activePage={this.state.activePage}
                        itemsCountPerPage={this.state.itemsCountPerPage}
                        totalItemsCount={this.state.total}
                        pageRangeDisplayed={this.state.pageRangeDisplayed}
                        onChange={this.handlePageChange.bind(this)}
                    />
                </div>
                <div className="col-md-2"></div>
            </div>)
        }
    }

    details(details) {
        const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
        if (details === null || details === '') {
            return (
                renderHTML(details)
            )
        } else {
            return (
                renderHTML(details.substr(0, 100))
            )
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //for mobile responsive
        if (isMobile) {
            return (
                <div className="wrapper">
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid main">
                        <div className="row">
                            {/* <div className="col-md-4 input_name">
                                        <SideBar />
                                    </div> */}
                            <div className="col-md-8">
                                <div className="mt-5 input_name big_font text-left" style={{ width: "100%", fontSize: '20px' }}>
                                    {this.props.t('1')}
                                </div>
                                <div style={{ minHeight: "550px" }}>
                                    <div className="custom_padding_dash pt-0">
                                        <div className="row">
                                            {this.state.favorites.map(group =>
                                                <div className="" style={{width:'100%'}}>
                                                    <div className="" key={group.id} style={{ height: '', width: '100%', border: "1px solid #f4f2f0", padding: "15px" }}>
                                                        <div className="row">
                                                            <div className="col-md-9 remember_text card" style={{ border: "0px solid" }}>
                                                                <div className="stars row pb-2">
                                                                    <div className="col-8">
                                                                        <Link to={{
                                                                            pathname: `/my-profile-view/users/${group.seller_id}`,
                                                                            state: { id: group.seller_id }
                                                                        }} >
                                                                            {group.first_name}
                                                                        </Link>
                                                                    </div>
                                                                    <div className="col-4">
                                                                        <b>{parseInt(group.price)}</b> {this.props.t('2')}
                                                                    </div>
                                                                </div>
                                                                <div className="">
                                                                    <Link to={{
                                                                        pathname: `/categories-details/${group.id}`,
                                                                        state: { id: group.product_id }
                                                                    }} style={{ textDecoration: 'none' }} className="card-title">
                                                                        <span style={{ color: "gray" }}><b>{group.title}</b></span><br />
                                                                    </Link>
                                                                </div>
                                                                <div className="diff_font">{group.short_desc}</div>
                                                                <div className="product_description " style={{ textDecoration: 'none', color: "gray", fontSize: '12' }}>
                                                                    {this.details(group.long_desc)}
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <img src={Common.baseUrl + group.proimg} alt="" style={{ width: "100%", height: "100px", objectFit: 'cover' }} />
                                                                <br />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <br />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                {this.pagination()}

                            </div>
                        </div>
                    </div>
                    <Footer />
                </div >
            )
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div className="wrapper">
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid main">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <SideBar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className=" mb-1 input_name big_font guide_text" style={{ width: "100%" }}>
                                            {this.props.t('1')}
                                    </div>
                                        <div style={{ minHeight: "550px" }}>
                                            <div className="custom_padding_dash pt-0">
                                                <div className="row">
                                                    {this.state.favorites.map(group =>
                                                        <div className="" style={{width:"100%"}}>
                                                            <div className="" key={group.id} style={{ height: '', width: '100%', border: "1px solid #f4f2f0", padding: "20px" }}>
                                                                <div className="row">
                                                                    <div className="col-md-9 remember_text card" style={{ border: "0px solid" }}>
                                                                        <div className="">
                                                                            <Link to={{
                                                                                pathname: `/categories-details/${group.id}`,
                                                                                state: { id: group.product_id }
                                                                            }} style={{ textDecoration: 'none' }} className="card-title">
                                                                                <span style={{ color: "gray" }}><b>{group.title}</b></span><br />
                                                                            </Link>
                                                                        </div>
                                                                        <div className="diff_font">{group.short_desc}</div>
                                                                        <div className="product_description " style={{ textDecoration: 'none', color: "gray", fontSize: '12' }}>
                                                                            {this.details(group.long_desc)}
                                                                        </div>
                                                                        <div className="mt-1 col-md-12 stars ">
                                                                            <div className="row">
                                                                                <Link to={{
                                                                                    pathname: `/my-profile-view/users/${group.seller_id}`,
                                                                                    state: { id: group.seller_id }
                                                                                }} >
                                                                                    {group.first_name}
                                                                                </Link>
                                                                                &nbsp;&nbsp;
                                                                    </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <img src={Common.baseUrl + group.proimg} alt="" style={{ width: "100%", height: "100px", objectFit: 'cover' }} />
                                                                        <br />
                                                                        <div className="mt-2 pl-3 ml-4">
                                                                            <b>{parseInt(group.price)}</b> {this.props.t('2')}
                                                                </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <br />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {this.pagination()}

                            </div>
                        </div>
                    </div>
                    <Footer />
                </div >
            )
        }
    }
}
export { SellerFavorites }


 SellerFavorites = withTranslation('src_Components_Seller_SellerFavorites')(SellerFavorites);
